// Libraries
import _debounce from 'lodash/debounce'

// Shared
import { getAvailabilities, getAvailability } from 'shop-components/api/availability'

let ids = []

const availabilitiesRequest = ({ dispatch, ...params }) => {
  dispatch({
    type: 'PRODUCT_AVAILABILITIES_FETCH_START'
  })

  getAvailabilities({ ids, ...params })
    .then(({ data: { data } }) => {
      const availabilities = data.map(({ attributes }) => attributes)

      dispatch({ type: 'PRODUCT_AVAILABILITIES_FETCH_SUCCESS', payload: { records: availabilities } })
    })
    .catch(() => {
      dispatch({
        type: 'PRODUCT_AVAILABILITIES_FETCH_ERROR'
      })
    })

  ids = []
}

const availabilityRequest = ({ dispatch, ...params }) => {
  dispatch({
    type: 'PRODUCT_AVAILABILITIES_FETCH_START'
  })

  getAvailability(params)
    .then(({ data: { data } }) => {
      const availabilities = data.map(({ attributes }) => attributes)

      dispatch({ type: 'PRODUCT_AVAILABILITIES_FETCH_SUCCESS', payload: { records: availabilities } })
    })
    .catch(() => {
      dispatch({
        type: 'PRODUCT_AVAILABILITIES_FETCH_ERROR'
      })
    })
}

const fetchAvailabilitiesDebounced = _debounce(availabilitiesRequest, 50)

const fetchAvailabilityDebounced = _debounce(availabilityRequest, 50)

// Bulk fetch actions are debounced to prevent multiple requests
export const fetchAvailabilities = ({ id, ...params }) => (dispatch) => {
  if (!ids.includes(id)) {
    ids.push(id)
  }

  return fetchAvailabilitiesDebounced({ ...params, dispatch })
}

export const fetchAvailability = (params) => (dispatch) => {
  return fetchAvailabilityDebounced({ ...params, dispatch })
}

export const fetchVariationAvailability = ({ productId, ...params }) => (dispatch) => {
  dispatch({
    type: 'PRODUCT_VARIATION_AVAILABILITIES_FETCH_START'
  })

  getAvailabilities(params)
    .then(({ data: { data } }) => {
      const availabilities = data.map(({ attributes }) => ({ ...attributes }))

      dispatch({
        type: 'PRODUCT_VARIATION_AVAILABILITIES_FETCH_SUCCESS',
        payload: { records: availabilities, productId }
      })
    })
    .catch(() => {
      dispatch({
        type: 'PRODUCT_VARIATION_AVAILABILITIES_FETCH_ERROR'
      })
    })
}
